import { getDescSortParam } from '../../../utils/sort'
import { TableCellSorting, TableCellSortingParamValue } from '../Table.enums'

import { SORT_PARAMS_MAX_COUNT } from './TableHeaderRow.constants'

export function getColumnTitle({ column, t }) {
  return column.rawTitle ?? (column.title ? t(column.title) : null)
}

export function getNextOrdering(fieldName, sortDirection, ordering) {
  const nextOrdering = ordering.filter(item => {
    // Handle situation like `created_by` and `created` columns
    // `includes` method won't work
    const name = item.includes(
      TableCellSortingParamValue[TableCellSorting.Desc]
    )
      ? item.slice(1, item.length)
      : item

    return name !== fieldName
  })

  if (sortDirection === TableCellSortingParamValue[TableCellSorting.Asc]) {
    nextOrdering.unshift(fieldName)
  } else if (
    sortDirection === TableCellSortingParamValue[TableCellSorting.Desc]
  ) {
    nextOrdering.unshift(getDescSortParam(fieldName))
  }

  // Limit filter by 5 column
  if (nextOrdering.length > SORT_PARAMS_MAX_COUNT) {
    nextOrdering.pop()
  }

  return nextOrdering
}
